import CustomerAccount from 'files/CustomerAccount.js';

const Customer = {

    // In-memory customer profile reference
    _customer: null,
    _listeners: [],

    // Restore a cached profile and, if returning from Shopify, complete sign-in.
    init: async () => {
        Customer._customer = CustomerAccount.getCachedCustomer();

        let callback = CustomerAccount.pendingCallback();
        if(callback) {
            try {
                Customer._customer = await CustomerAccount.completeLogin(callback);
            } catch(e) {
                console.error('Error completing sign-in:', e);
            } finally {
                // strip the oauth params from the url regardless of outcome
                window.history.replaceState({}, document.title, window.location.pathname);
            }
            Customer._notifyListeners();
        }
        return Customer._customer;
    },

    get: () => Customer._customer,

    isAuthenticated: () => !!Customer._customer,

    // Redirect to "Sign in with Shop"
    login: () => CustomerAccount.login(),

    logout: async () => {
        await CustomerAccount.logout();
        Customer._customer = null;
        Customer._notifyListeners();
    },

    // Fetch order history (with tracking) for the signed-in customer
    getOrders: () => CustomerAccount.fetchOrders(),

    subscribe: (listener) => {
        Customer._listeners.push(listener);
        return () => {
            Customer._listeners = Customer._listeners.filter(l => l !== listener);
        };
    },

    _notifyListeners: () => {
        Customer._listeners.forEach(listener => {
            try {
                listener(Customer._customer);
            } catch(e) {
                console.error('Error notifying customer listener:', e);
            }
        });
    },
};

export default Customer;
